module.exports = __webpack_public_path__ + "images/90cfda6e7c98c8776f434fbc11baddc2-spiritairlines.jpg";